<template>
  <div>
    <!-- <h1>機能実装</h1> -->
    <!-- <p>{{this.$store.state.filter}}</p> -->
    <!-- <p><button v-on:click="click">子から親にイベント発火</button></p><br> -->
    <!-- <p><button v-on:click="resetAll">resetAll</button></p><br> -->
    <div class="lineup__filterBlock">
      <div class="lineup__filterBlockSpacer"></div>
      <ul class="lineup__filter">
        <li class="lineup__filterLiSpTitle">
          <span class="display--pc">ソートする</span>
          <span class="display--sp"><img src="share/images/lineup_txt_sort.svg" width="71" alt="ソートする"></span>
        </li>
        <li class="lineup__filterLi">
          <dl>
            <dt>
              <span class="display--pc">革素材で選ぶ</span>
              <span class="display--sp"><img src="share/images/lineup_txt_select1.svg" width="40" alt="革素材で選ぶ"></span>
            </dt>
            <dd>
              <ul class="lineup__filterSub">
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="1" v-model="all">
                      <span class="display--pc">本革</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans11.svg" width="30" alt="本革"></span>
                      <i class="lineup__filterSubLiIcon--hon"></i><i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="2" v-model="all">
                      <span class="display--pc">合成皮革</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans12.svg" width="59" alt="合成皮革"></span>
                      <i class="lineup__filterSubLiIcon--gou"></i><i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="3" v-model="all">
                      <span class="display--pc">スコッチガード</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans13.svg" width="94" alt="スコッチガード"></span>
                      <i class="lineup__filterSubLiIcon--su"></i><i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
              </ul>
            </dd>
          </dl>
        </li>
        <li class="lineup__filterLi">
          <dl>
            <dt>
              <span class="display--pc">ワイズで選ぶ</span>
              <span class="display--sp"><img src="share/images/lineup_txt_select2.svg" width="40" alt="ワイズで選ぶ"></span>
            </dt>
            <dd>
              <ul class="lineup__filterSub">
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="4" v-model="all">
                      <span class="display--pc">1E</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans21.svg" width="17" alt="1E"></span>
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="5" v-model="all">
                      <span class="display--pc">2E</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans22.svg" width="18" alt="2E"></span>
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="6" v-model="all">
                      <span class="display--pc">3E</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans23.svg" width="18" alt="3E"></span>
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
              </ul>
            </dd>
          </dl>
        </li>
        <li class="lineup__filterLi">
          <dl>
            <dt>
              <span class="display--pc">色で選ぶ</span>
              <span class="display--sp"><img src="share/images/lineup_txt_select3.svg" width="40" alt="色で選ぶ"></span>
            </dt>
            <dd>
              <ul class="lineup__filterSub">
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="7" v-model="all">
                      <span class="display--pc">ブラック</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans31.svg" width="54" alt="ブラック"></span>
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="8" v-model="all">
                      <span class="display--pc">ブラウン</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans32.svg" width="55" alt="ブラウン"></span>
                    
                    
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="9" v-model="all">
                      <span class="display--pc">ローター</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans33.svg" width="55" alt="ローター"></span>
                    
                    
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="10" v-model="all">
                      <span class="display--pc">ジャマイカ</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans34.svg" width="67" alt="ジャマイカ"></span>
                    
                    
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
              </ul>
            </dd>
          </dl>
        </li>
        <li class="lineup__filterLi">
          <dl>
            <dt>
              <span class="display--pc">デザインで選ぶ</span>
              <span class="display--sp"><img src="share/images/lineup_txt_select4.svg" width="49" alt="デザインで選ぶ"></span>
            </dt>
            <dd>
              <ul class="lineup__filterSub">
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="11" v-model="all">
                      <span class="display--pc">コイン</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans41.svg" width="39" alt="コイン"></span>
                    
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="12" v-model="all">
                      <span class="display--pc">タッセル</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans42.svg" width="56" alt="タッセル"></span>
                    
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="13" v-model="all">
                      <span class="display--pc">キルトタッセル</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans43.svg" width="99" alt="キルトタッセル"></span>
                    
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
              </ul>
            </dd>
          </dl>
        </li>
        <li class="lineup__filterLi">
          <dl>
            <dt>
              <span class="display--pc">ヒールで選ぶ</span>
              <span class="display--sp"><img src="share/images/lineup_txt_select5.svg" width="40" alt="ヒールで選ぶ"></span>
            </dt>
            <dd>
              <ul class="lineup__filterSub">
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="14" v-model="all">
                      <span class="display--pc">低い</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans51.svg" width="28" alt="低い"></span>
                                        
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
                <li class="lineup__filterSubLi">
                  <label v-on:click.prevent="clickLabel">
                    <input type="radio" value="15" v-model="all">
                      <span class="display--pc">高い</span>
                      <span class="display--sp"><img src="share/images/lineup_txt_ans52.svg" width="28" alt="高い"></span>
                                        
                    <i class="lineup__filterSubLiIcon--check"></i>
                  </label>
                </li>
              </ul>
            </dd>
          </dl>
        </li>
      </ul>
      <!--

      <div class="example">{{ msg }}</div>
      <h4>素材｜{{ mat }}</h4>
      <label><input type="checkbox" value="1" v-model="mat">本皮</label>
      <label><input type="checkbox" value="2" v-model="mat">合成</label>
      <label><input type="checkbox" value="3" v-model="mat">スコッチ</label>
      <h4>ワイズ｜{{ wid }}</h4>
      <label><input type="checkbox" value="1" v-model="wid">1E</label>
      <label><input type="checkbox" value="2" v-model="wid">1E</label>
      <label><input type="checkbox" value="3" v-model="wid">1E</label>
      <h4>色｜{{ col }}</h4>
      <label><input type="checkbox" value="1" v-model="col">色</label>
      <label><input type="checkbox" value="2" v-model="col">色</label>
      <label><input type="checkbox" value="3" v-model="col">色</label>
      <h4>デザイン｜{{ des }}</h4>
      <label><input type="checkbox" value="1" v-model="des">デザイン</label>
      <label><input type="checkbox" value="2" v-model="des">デザイン</label>
      <label><input type="checkbox" value="3" v-model="des">デザイン</label>
      <h4>ヒール｜{{ hee }}</h4>
      <label><input type="checkbox" value="1" v-model="hee">デザイン</label>
      <label><input type="checkbox" value="2" v-model="hee">デザイン</label>
      <label><input type="checkbox" value="3" v-model="hee">デザイン</label>

      {{ $store.state.message }}
      {{ message }}

       -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
// import Vue from 'vue';
// 『イベントバス』のためのインスタンス
// var bus = new Vue();

export default {
  name: 'FilterSelect',
  data () {
    return {
      // msg: 'Hello Vue Component   ttm',
    }
  },
  mounted : function(){
    // this.pullDown();
    // this.setFixed();
  },
  computed : {
    message : function(){
      return this.$store.state.message
    },
    all: {
      get () {
        return this.$store.state.filter.all
      },
      set (value) {
        this.$store.commit('setAll', value)
      }
    },
    // mat: {
    //   get () {
    //     return this.$store.state.filter.mat
    //   },
    //   set (value) {
    //     this.$store.commit('setMat', value)
    //   }
    // },
    // wid: {
    //   get () {
    //     return this.$store.state.filter.wid
    //   },
    //   set (value) {
    //     this.$store.commit('setWid', value)
    //   }
    // },
    // col: {
    //   get () {
    //     return this.$store.state.filter.col
    //   },
    //   set (value) {
    //     this.$store.commit('setCol', value)
    //   }
    // },
    // des: {
    //   get () {
    //     return this.$store.state.filter.des
    //   },
    //   set (value) {
    //     this.$store.commit('setDes', value)
    //   }
    // },
    // hee: {
    //   get () {
    //     return this.$store.state.filter.hee
    //   },
    //   set (value) {
    //     this.$store.commit('setHee', value)
    //   }
    // },
  },

  // watch: {
  //   mat: function (newValue, oldValue) {
  //     console.log(newValue, oldValue);
  //   },
  // },

  methods: {
    clickLabel: function(e){
        var input = $(e.currentTarget).find('input');
        if(input.is(':checked')) {
            input.prop('checked', false);
            this.$store.commit('setAll', '');
        } else {
            input.prop('checked', true);
            this.$store.commit('setAll', input.val());
        }

        var speed = 400;
        var position = $('.lineup__filterBlock').offset().top;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
    },
    click: function(){
        this.$emit('child-event', this.hee);//親へイベント発火を伝える

        this.$store.commit('setMat', this.mat);
        this.$store.commit('setWid', this.wid);
        this.$store.commit('setCol', this.col);
        this.$store.commit('setDes', this.des);
        this.$store.commit('setHee', this.hee);
        // bus.$emit('bus-event', this.hee);
    },
    resetAll: function(){
        this.$store.commit('setMat', []);
        this.$store.commit('setWid', []);
        this.$store.commit('setCol', []);
        this.$store.commit('setDes', []);
        this.$store.commit('setHee', []);
    },
    // pullDown: function(){
    // },
    // setFixed: function(){

    //   console.log('?');

    // }
  }
}
</script>

<style>
</style>
